import React from 'react';
import { DateTimePicker } from '@/components/ui/DateTimePicker';
import { InventoryState } from '@/types';

interface StatementFilterProps {
  value: number;
  states: InventoryState[];
  onChange: (stateId: number) => void;
  disabled?: boolean;
}

export const StatementFilter: React.FC<StatementFilterProps> = ({
  value,
  states,
  onChange,
  disabled = false,
}) => {
  return (
    <div data-tour="inventory-statement">
      <h3 className="text-sm font-medium text-gray-700 mb-3">Statement</h3>
      <DateTimePicker
        value={value}
        states={states}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

